module.exports = __webpack_public_path__ + "d308073b/img/search-filter-icon.c4751a52.svg";